import React, { useContext } from 'react';
import cx from 'classnames';
import { useMatch } from 'react-router-dom';
import { OfferStatusContext } from 'components/Providers/OfferStatusProvider';
import { MediaQueryContext } from '@arrive/responsive-provider';

// Components
import SVGIcon from '@arrive/svg-icon';

// Constants
import { ROUTES } from 'constants/routeConstants';
import { OfferStatusId } from 'sharedTypes/offers/offers';

// SVGs
import ARRIVE_FOOTER_LOGO from 'assets/arrive-logo-footer.svg';
import FACEBOOK from 'assets/facebook-f.svg';
import INSTAGRAM from 'assets/instagram.svg';
import TWITTER from 'assets/twitter.svg';
import LINKEDIN from 'assets/linkedin-in.svg';

import styles from './Footer.scss';

const Footer = () => {
  const [offerStatus, _] = useContext(OfferStatusContext); // eslint-disable-line
  const currentMediaTypes = useContext(MediaQueryContext);
  const isLoadDetail = !!useMatch(ROUTES.loadDetail);
  const isResponsive = currentMediaTypes.xs || currentMediaTypes.sm;

  return (
    <div className={cx(styles.footerWrapper, { [styles.footerStickyPadding]: isLoadDetail, [styles.availableCounterBuffer]: isResponsive && offerStatus === OfferStatusId.BIZ_COUNTER, [styles.availableAcceptedBuffer]: isResponsive && offerStatus === OfferStatusId.ACCEPTED, [styles.sideRailBuffer]: isResponsive && isLoadDetail })}>
      <footer className={styles.container}>
        <div className={styles.linksContainer}>
          <div className={styles.logo}><SVGIcon svgRef={ARRIVE_FOOTER_LOGO} /></div>
          <div className={cx(styles.stackedContent, styles.about)}>
            <span className={styles.stackedContentHeader}>ABOUT</span>
            <a href={'https://www.arrivelogistics.com/about/'} rel="noopener noreferrer" target={'_blank'}>Our Story</a>
            <a href={'https://www.arrivelogistics.com/carriers/carrier-portal/'} rel="noopener noreferrer" target={'_blank'}>Technology</a>
            <a href={'https://www.arrivelogistics.com/careers/'} rel="noopener noreferrer" target={'_blank'}>Careers at Arrive</a>
            <a href={'https://www.arrivelogistics.com/category/press/'} rel="noopener noreferrer" target={'_blank'}>Press</a>
            <a href={'https://www.arrivelogistics.com/category/awards/'} rel="noopener noreferrer" target={'_blank'}>Awards</a>
          </div>
          <div className={cx(styles.stackedContent, styles.resources)}>
            <span className={styles.stackedContentHeader}>RESOURCES</span>
            <a href={'https://arrivelogisticscarriers.rmissecure.com/_s/reg/GeneralRequirementsV2.aspx'} rel="noopener noreferrer" target={'_blank'}>Join our carrier network</a>
            <a href={'https://www.arrivelogistics.com/carriers/'} rel="noopener noreferrer" target={'_blank'}>Never drive empty</a>
            <a href={'https://www.arrivelogistics.com/glossary/'} rel="noopener noreferrer" target={'_blank'}>Glossary</a>
          </div>
          <div className={cx(styles.stackedContent, styles.support)}>
            <span className={styles.stackedContentHeader}>SUPPORT</span>
            <span className={styles.heavyText}>Need 24/7 help on the road?</span>
            <span>Call Driver Services <a href={'tel:+18888610650'} rel="noopener noreferrer" target={'_blank'}>(888) 861-0650</a> x1 for Dispatch</span>
            <span className={styles.heavyText}>Compliance question?</span>
            <span>Email us at <a href={'mailto:carrierrelations@arrivelogistics.com'} rel="noopener noreferrer" target={'_blank'}>carrierrelations@arrivelogistics.com</a></span>
            <span className={styles.heavyText}>Have an accounting question?</span>
            <span>Email us at <a href={'mailto:accounting@arrivelogistics.com'} rel="noopener noreferrer" target={'_blank'}>accounting@arrivelogistics.com</a></span>
          </div>
        </div>
        <div className={styles.socialContainer}>
          <span>&#169;2020 Arrive Logistics. All rights reserved</span>
          <a className={styles.privacy} href={'https://www.arrivelogistics.com/privacy/'} rel="noopener noreferrer" target={'_blank'}>Privacy</a>
          <div className={styles.socialContentRight}>
            <a href={'https://www.facebook.com/ArriveWithUs'} rel="noopener noreferrer" target={'_blank'}><SVGIcon svgRef={FACEBOOK} /></a>
            <a href={'https://www.instagram.com/arrivelogistics/'} rel="noopener noreferrer" target={'_blank'}><SVGIcon svgRef={INSTAGRAM} /></a>
            <a href={'https://twitter.com/arrivelogistics'} rel="noopener noreferrer" target={'_blank'}><SVGIcon svgRef={TWITTER} /></a>
            <a href={'https://www.linkedin.com/company/arrive-logistics'} rel="noopener noreferrer" target={'_blank'}><SVGIcon svgRef={LINKEDIN} /></a>
          </div>
        </div>
      </footer>

    </div >
  );
};

export default Footer;
